
/**
 * +==============================================================+
 * |  BORKIFY MODERATION ENGINE v2.0                             |
 * |  Sistema de proteccion de El Club Borkify                   |
 * |  Arquitectura: Layer 1 (Blacklist) + Layer 2 (Heuristica)  |
 * |  + Image Pipeline + Status Workflow + Admin Panel           |
 * +==============================================================+
 */



// +==============================================================+
// |        BORKIFY MODERATION ENGINE v2.0                       |
// |  Sistema de proteccion de comunidad para El Club Borkify    |
// +==============================================================+
(function() {
  'use strict';

  // -------------------------------------------------------------
  // CONFIGURACION GLOBAL DEL SISTEMA
  // -------------------------------------------------------------
  const BCF_MOD_CONFIG = {
    // Umbral de confianza para bloqueo automatico (0.0 - 1.0)
    AUTO_REJECT_THRESHOLD: 0.80,
    // Umbral para envio a revision manual (estado "flagged")
    FLAG_THRESHOLD: 0.50,
    // Tamano maximo de imagen en bytes (5MB)
    MAX_IMAGE_SIZE: 5 * 1024 * 1024,
    // Formatos de imagen permitidos
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    // Longitud minima/maxima del texto de un post
    MIN_TEXT_LENGTH: 10,
    MAX_TEXT_LENGTH: 2000,
    // Maximo de URLs externas permitidas en un post
    MAX_EXTERNAL_LINKS: 0,
    // Mostrar boton de admin? (activar en sesion de admin)
    IS_ADMIN: false,
  };

  // -------------------------------------------------------------
  // CAPA 1A: LISTA NEGRA LOCAL - PALABRAS PROHIBIDAS
  // Insultos en espanol, lenguaje adulto, terminos politicos
  // polarizantes, spam de criptomonedas y afiliados
  // -------------------------------------------------------------
  const BCF_BLACKLIST = {

    // Insultos y groserias directas en espanol
    profanity: [
      'puta','puto','mierda','cono','joder','hostia','gilipollas',
      'imbecil','imbecil','idiota','estupido','estupido','maldito',
      'cabron','cabron','pendejo','culero','chingada','chinga',
      'hijoputa','hijo de puta','marica','maricon','maricon',
      'perra','perro' /* en contexto insultante */,
      'zorra','zorras','puta madre','la concha','conchuda',
      'pelotudo','boludo','gil','hdp','vete a la mierda',
      'culo','culo de','la polla','la verga','verga','picha',
      'follar','coger' /* en contexto sexual */,
    ],

    // Discurso de odio y discriminacion
    hate_speech: [
      'nazi','nazis','hitler','raza inferior','raza superior',
      'matar a todos','muerte a','terrorismo','terrorista',
      'bomba','armas','droga','drogas','cocaina','cocaina',
      'heroina','heroina','fentanilo','narcotrafico',
    ],

    // Politica polarizante (prohibida en la comunidad)
    politics: [
      'vox','psoe','pp partido','podemos politica','ciudadanos partido',
      'elecciones 20','fraude electoral','dictadura','comunismo',
      'fascismo','fascista','republicano','democrata partido',
      'trump','biden','sanchez politica','feijoo','ayuso politica',
      'socialismo','capitalismo debate','marxismo','ultras',
      'izquierda radical','derecha radical','progre','facha',
      'antifa','golpe de estado','corrupcion politica',
    ],

    // Spam de afiliados, criptomonedas y timos
    spam_patterns: [
      'gana dinero','ganar dinero facil','inversion garantizada',
      'bitcoin gratis','crypto gratis','nft','web3 gratis',
      'haz clic aqui','click aqui','bit.ly','tinyurl',
      'descuento exclusivo' /* si no es de Borkify */,
      'negocio desde casa','mlm','multinivel','amway',
      'herbalife','piramide','dupla','cadena de favores',
      'urgente responde','enviame','mandame','whatsapp al',
      '18+','solo adultos','citas gratis',
    ],

    // Contenido adulto / sexual
    adult: [
      'sexo','sexual','porno','pornografia','pornografia',
      'onlyfans','only fans','pack nsfw','contenido adulto',
      'desnuda','desnudo','xxx',
    ],
  };

  // -------------------------------------------------------------
  // FUNCION: Normalizar texto para el analisis
  // Elimina tildes, convierte a minusculas, elimina dobles espacios
  // -------------------------------------------------------------
  function bcfNormalizeText(text) {
    return text
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // quitar tildes
      .replace(/[^a-z0-9\s]/g, ' ')  // solo alfanumerico
      .replace(/\s+/g, ' ')
      .trim();
  }

  // -------------------------------------------------------------
  // FUNCION: Escanear texto con lista negra (Capa 1)
  // Retorna: { blocked: bool, category: string, matchedWord: string, score: float }
  // -------------------------------------------------------------
  function bcfLayer1TextScan(text) {
    const normalized = bcfNormalizeText(text);
    const categories = Object.keys(BCF_BLACKLIST);

    for (const category of categories) {
      const words = BCF_BLACKLIST[category];
      for (const word of words) {
        const normalizedWord = bcfNormalizeText(word);
        if (normalized.includes(normalizedWord)) {
          return {
            blocked: true,
            category: category,
            matchedWord: word,
            score: 1.0,
            layer: 'blacklist',
          };
        }
      }
    }

    // Detectar URLs externas (spam de links)
    const urlPattern = /(https?:\/\/|www\.)[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/gi;
    const urlMatches = text.match(urlPattern) || [];
    const externalLinks = urlMatches.filter(url =>
      !url.includes('borkify') && !url.includes('shopify')
    );

    if (externalLinks.length > BCF_MOD_CONFIG.MAX_EXTERNAL_LINKS) {
      return {
        blocked: true,
        category: 'spam_patterns',
        matchedWord: externalLinks[0],
        score: 0.95,
        layer: 'url_detection',
        detail: 'URL externa detectada: ' + externalLinks[0],
      };
    }

    // Texto demasiado corto
    if (text.trim().length < BCF_MOD_CONFIG.MIN_TEXT_LENGTH) {
      return {
        blocked: false,
        category: 'too_short',
        score: 0,
        layer: 'length_check',
        warning: 'El texto es muy corto.',
      };
    }

    return { blocked: false, score: 0, layer: 'blacklist' };
  }


  // -------------------------------------------------------------
  // CAPA 2: OPENAI MODERATION API
  // Detecta: hate, harassment, self-harm, sexual, violence
  // Se llama solo si la Capa 1 no bloqueo el contenido
  // -------------------------------------------------------------

  /*
   * NOTA PARA IMPLEMENTACION EN PRODUCCION:
   * -----------------------------------------
   * La llamada a OpenAI Moderation API NUNCA debe hacerse
   * desde el frontend (expone la API key).
   * 
   * ARQUITECTURA CORRECTA:
   *   Frontend -> POST /api/moderate -> Shopify Function / Serverless -> OpenAI API
   *
   * Para Shopify especificamente, usar:
   *   Option A: Shopify Functions (Edge)
   *   Option B: Shopify App Proxy -> Node.js/Express backend
   *   Option C: Vercel/Netlify Serverless Function
   *
   * El endpoint /api/moderate recibe { text, image_url? }
   * y retorna { status, score, categories, reason }
   *
   * --- CODIGO DEL SERVIDOR (Node.js/Express) -------------------
   *
   * // server/routes/moderate.js
   * const express = require('express');
   * const router = express.Router();
   * const OpenAI = require('openai');
   * const Rekognition = require('@aws-sdk/client-rekognition');
   *
   * const openai = new OpenAI({ apiKey: process.env.OPENAI_API_KEY });
   * const rekognition = new Rekognition.RekognitionClient({ region: 'us-east-1' });
   *
   * router.post('/moderate', async (req, res) => {
   *   const { text, image_url } = req.body;
   *   const result = { status: 'approved', score: 0, categories: {}, reason: null };
   *
   *   // -- TEXTO: OpenAI Moderation ------------------------------
   *   if (text) {
   *     const modResp = await openai.moderations.create({ input: text });
   *     const r = modResp.results[0];
   *     const maxScore = Math.max(...Object.values(r.category_scores));
   *     result.score = maxScore;
   *     result.categories = r.category_scores;
   *     if (r.flagged) {
   *       const topCategory = Object.entries(r.category_scores)
   *         .sort((a,b) => b[1] - a[1])[0];
   *       if (maxScore >= 0.80) {
   *         result.status = 'rejected';
   *         result.reason = topCategory[0];
   *       } else if (maxScore >= 0.50) {
   *         result.status = 'flagged';
   *         result.reason = topCategory[0];
   *       }
   *     }
   *   }
   *
   *   // -- IMAGEN: AWS Rekognition -------------------------------
   *   if (image_url && result.status !== 'rejected') {
   *     const imgResp = await rekognition.send(new Rekognition.DetectModerationLabelsCommand({
   *       Image: { Bytes: await fetchImageAsBuffer(image_url) },
   *       MinConfidence: 50,
   *     }));
   *     const labels = imgResp.ModerationLabels || [];
   *     const dangerous = labels.filter(l => l.Confidence >= 80);
   *     const BLOCKED_LABELS = [
   *       'Explicit Nudity','Nudity','Sexual Activity','Graphic Violence',
   *       'Blood & Gore','Animal Abuse','Self Injury','Drug Use'
   *     ];
   *     const hit = dangerous.find(l => BLOCKED_LABELS.includes(l.Name));
   *     if (hit) {
   *       result.status = 'rejected';
   *       result.reason = 'image_' + hit.Name.toLowerCase().replace(/ /g,'_');
   *       result.score = hit.Confidence / 100;
   *     } else if (dangerous.length > 0) {
   *       result.status = 'flagged';
   *       result.reason = 'image_review_required';
   *     }
   *   }
   *
   *   // -- GUARDAR EN DB: status pending_review -> approved/rejected/flagged
   *   await db.posts.updateStatus(req.body.postId, result.status);
   *   res.json(result);
   * });
   * -------------------------------------------------------------
   */

  // -------------------------------------------------------------
  // CLIENTE FRONTEND: Llama al endpoint de moderacion seguro
  // En produccion: reemplazar URL con tu endpoint real
  // Por ahora usa simulacion local con heuristicas
  // -------------------------------------------------------------
  async function bcfLayer2TextMod(text) {
    // ----------------------------------------------------------------
    // PRODUCCION: Llama al endpoint seguro de moderacion de texto.
    // El endpoint llama a OpenAI Moderation API internamente.
    // La API key NUNCA se expone en el frontend.
    //
    // CONFIGURA: Cambia la URL por tu endpoint real cuando lo despliegues.
    //   Vercel:  https://tu-proyecto.vercel.app/api/moderate
    //   Netlify: https://tu-proyecto.netlify.app/.netlify/functions/moderate
    //   VPS:     https://api.borkify.com/api/moderate
    // ----------------------------------------------------------------
    const MODERATION_ENDPOINT = (
      window.BORKIFY_MOD_ENDPOINT ||        // Configurable desde Liquid: {{ settings.mod_endpoint }}
      'https://your-backend.vercel.app/api/moderate' // <-- CAMBIA ESTO
    );

    try {
      const response = await fetch(MODERATION_ENDPOINT + '?type=text', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ text: text }),
        signal:  AbortSignal.timeout(8000), // timeout de 8 segundos
      });

      if (!response.ok) {
        // Si el servidor falla, aprobamos de forma conservadora
        console.warn('[Borkify Mod] Moderation endpoint error:', response.status);
        return { status: 'approved', score: 0, category: null };
      }

      const result = await response.json();
      // result = { status: "approved"|"rejected"|"flagged", score, reason, category }
      return {
        status:   result.status   || 'approved',
        score:    result.score    || 0,
        category: result.reason   || result.category || null,
      };

    } catch (error) {
      // Timeout o error de red: no penalizar al usuario
      console.warn('[Borkify Mod] Text moderation unavailable:', error.message);
      return { status: 'approved', score: 0, category: null };
    }
  }

  // -------------------------------------------------------------
  // PIPELINE DE MODERACION DE IMAGEN (Frontend)
  // Valida formato, tamano y realiza analisis basico de colores
  // Para analisis NSFW real -> llamar al endpoint backend
  // -------------------------------------------------------------
  async function bcfImageModerationPipeline(file) {
    const result = { status: 'approved', score: 0, reason: null };

    // Validacion basica: formato
    if (!BCF_MOD_CONFIG.ALLOWED_IMAGE_TYPES.includes(file.type)) {
      return {
        status: 'rejected',
        score: 1.0,
        reason: 'invalid_format',
        userMessage: 'Solo se permiten imagenes JPG, PNG, GIF o WEBP.',
      };
    }

    // Validacion basica: tamano
    if (file.size > BCF_MOD_CONFIG.MAX_IMAGE_SIZE) {
      return {
        status: 'rejected',
        score: 1.0,
        reason: 'file_too_large',
        userMessage: 'La imagen no puede superar 5MB. Comprime un poquito a tu peludo!',
      };
    }

    // Analisis de color sospechoso (heuristica de sangre/violencia)
    try {
      const redScore = await bcfAnalyzeImageRedContent(file);
      if (redScore > 0.45) {
        return {
          status: 'flagged',
          score: redScore,
          reason: 'high_red_content',
          userMessage: null, // Va a revision manual, no se bloquea aun
        };
      }
    } catch(e) { /* Si falla el analisis, continuar */ }

    return result;
  }

  // -------------------------------------------------------------
  // ANALISIS DE CONTENIDO ROJO EN IMAGEN
  // Heuristica rapida en canvas para detectar posible sangre/violencia
  // Un score > 0.45 envia a revision manual (estado "flagged")
  // -------------------------------------------------------------
  function bcfAnalyzeImageRedContent(file) {
    // ----------------------------------------------------------------
    // PRODUCCION: Esta funcion ahora convierte la imagen a base64
    // y la envia al endpoint de moderacion de imagen (AWS Rekognition).
    // La logica de canvas/color fue reemplazada por IA real.
    // ----------------------------------------------------------------
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = async function(e) {
        const base64Data = e.target.result; // "data:image/jpeg;base64,..."

        const MODERATION_ENDPOINT = (
          window.BORKIFY_MOD_ENDPOINT ||
          'https://your-backend.vercel.app/api/moderate'
        );

        try {
          const response = await fetch(MODERATION_ENDPOINT + '?type=image', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ imageBase64: base64Data }),
            signal:  AbortSignal.timeout(15000), // 15s para imagen (Rekognition es mas lento)
          });

          if (!response.ok) {
            console.warn('[Borkify Mod] Image moderation endpoint error:', response.status);
            resolve(0); // Si falla, no bloquear
            return;
          }

          const result = await response.json();
          // Devolver un score numerico para compatibilidad con bcfImageModerationPipeline
          // 0 = limpia, 0.5+ = zona gris (flagged), 0.8+ = bloqueada
          if (result.status === 'rejected') { resolve(result.score || 0.9); }
          else if (result.status === 'flagged') { resolve(result.score || 0.55); }
          else { resolve(0); }

        } catch (error) {
          console.warn('[Borkify Mod] Image moderation unavailable:', error.message);
          resolve(0); // Error de red: no penalizar
        }
      };
      reader.onerror = () => resolve(0);
      reader.readAsDataURL(file); // Convertir a base64
    });
  }


  // -------------------------------------------------------------
  // WORKFLOW PRINCIPAL DE ESTADOS DEL POST
  // -------------------------------------------------------------
  // Estado inicial al publicar: "pending_review"
  // Flujo:
  //   pending_review -> [Capa1 + Capa2] -> approved | rejected | flagged
  //
  // ESQUEMA DE BASE DE DATOS (referencia para backend):
  // -------------------------------------------------------------
  // posts {
  //   id:          UUID (primary key)
  //   author_id:   UUID (FK usuarios)
  //   title:       TEXT
  //   body:        TEXT
  //   image_url:   TEXT | NULL
  //   tag:         ENUM('presume','trucos','salud','anecdota')
  //   status:      ENUM('pending_review','approved','rejected','flagged')  <- CAMPO CLAVE
  //   mod_score:   FLOAT (0.0 - 1.0) - puntuacion de riesgo de la IA
  //   mod_reason:  TEXT | NULL - categoria de rechazo
  //   mod_layer:   TEXT | NULL - que capa lo detecto
  //   reviewed_by: UUID | NULL - admin que reviso manualmente
  //   created_at:  TIMESTAMP
  //   updated_at:  TIMESTAMP
  // }
  // -------------------------------------------------------------

  // Estado de la bandeja de revision manual (en memoria para demo)
  const BCF_REVIEW_QUEUE = [];
  let BCF_POST_ID_COUNTER = 100;

  // -------------------------------------------------------------
  // FUNCION PRINCIPAL: Procesar envio de post
  // Llama a Capa1 -> Capa2 -> imagen -> decide status
  // -------------------------------------------------------------
  async function bcfModerationPipeline(postData) {
    // { title, body, tag, imageFile? }
    const fullText = (postData.title || '') + ' ' + (postData.body || '');

    // -- PASO 1: Validaciones basicas -------------------------
    if (!postData.title || postData.title.trim().length < 3) {
      return {
        status: 'rejected',
        reason: 'missing_title',
        userMessage: 'Ponle un titulo a tu publicacion! (minimo 3 caracteres)',
      };
    }
    if (!postData.body || postData.body.trim().length < BCF_MOD_CONFIG.MIN_TEXT_LENGTH) {
      return {
        status: 'rejected',
        reason: 'too_short',
        userMessage: 'Cuentanos mas! El texto necesita al menos 10 caracteres.',
      };
    }

    // -- PASO 2: Capa 1 - Lista Negra Local -------------------
    const layer1Result = bcfLayer1TextScan(fullText);
    if (layer1Result.blocked && layer1Result.score >= BCF_MOD_CONFIG.AUTO_REJECT_THRESHOLD) {
      return {
        status: 'rejected',
        reason: layer1Result.category,
        matchedWord: layer1Result.matchedWord,
        score: layer1Result.score,
        layer: 'blacklist',
        userMessage: bcfGetRejectionMessage(layer1Result.category),
      };
    }

    // -- PASO 3: Capa 2 - Analisis Heuristico / OpenAI --------
    const layer2Result = await bcfLayer2TextMod(fullText);
    if (layer2Result.status === 'rejected') {
      return {
        status: 'rejected',
        reason: layer2Result.category,
        score: layer2Result.score,
        layer: 'ai_moderation',
        userMessage: bcfGetRejectionMessage(layer2Result.category),
      };
    }

    // -- PASO 4: Moderacion de imagen (si existe) -------------
    if (postData.imageFile) {
      const imgResult = await bcfImageModerationPipeline(postData.imageFile);
      if (imgResult.status === 'rejected') {
        return {
          status: 'rejected',
          reason: imgResult.reason,
          score: imgResult.score,
          layer: 'image_pipeline',
          userMessage: imgResult.userMessage || bcfGetRejectionMessage('image_content'),
        };
      }
      if (imgResult.status === 'flagged') {
        // Imagen dudosa -> revision manual, post queda oculto
        return {
          status: 'flagged',
          reason: imgResult.reason,
          score: imgResult.score,
          layer: 'image_pipeline',
          userMessage: null, // Sin mensaje de error, se procesa silenciosamente
        };
      }
    }

    // -- PASO 5: Zona gris? (score 50-80%) -> flagged ---------
    if (layer2Result.status === 'flagged' || layer1Result.score >= BCF_MOD_CONFIG.FLAG_THRESHOLD) {
      return {
        status: 'flagged',
        reason: layer2Result.category || layer1Result.category,
        score: Math.max(layer2Result.score, layer1Result.score),
        layer: 'grey_zone',
        userMessage: null,
      };
    }

    // -- PASO 6: Todo OK -> APROBADO ---------------------------
    return { status: 'approved', score: 0, reason: null };
  }

  // -------------------------------------------------------------
  // MENSAJES DE RECHAZO AMIGABLES PARA EL USUARIO
  // Tono Borkify: empatico, no agresivo, con humor canino
  // -------------------------------------------------------------
  function bcfGetRejectionMessage(category) {
    const messages = {
      profanity:
        '[!] En el Club Borkify cuidamos la paz de la manada. Tu publicacion ha sido bloqueada por contener lenguaje ofensivo. Mantengamos esto divertido para los perritos! [paw]',
      hate_speech:
        '[!] El Club Borkify es un espacio libre de odio. Esta publicacion ha sido bloqueada por detectarse discurso discriminatorio. Los perros no entienden de eso y nosotros tampoco! [paw]',
      hate_speech_contextual:
        '[!] En el Club Borkify cuidamos la paz de la manada. Tu publicacion ha sido bloqueada por no cumplir con nuestras normas de comunidad. Mantengamos esto divertido para los perritos! [paw]',
      politics:
        '[!] El Club Borkify es una zona libre de politica. Aqui solo hablamos de perros, juguetes y amor peludo! Tu publicacion no ha podido publicarse. [paw]',
      spam_patterns:
        '[!] Hemos detectado contenido de spam o publicidad no autorizada. Si tienes un negocio de mascotas, contactanos por colaboraciones. Tu publicacion ha sido bloqueada. [paw]',
      spam_repetition:
        '[!] Parece que tu texto se repite mucho! Asegurate de escribir un mensaje original. Tu publicacion no ha podido publicarse. [paw]',
      adult:
        '[!] El Club Borkify es para toda la familia. Se ha detectado contenido para adultos en tu publicacion y ha sido bloqueada. Aqui todo es perruno y familiar! [paw]',
      image_content:
        '[paw] Vaya, parece que esta foto no cumple con las normas del Club. Asegurate de que salga tu peludo feliz y sin contenido inapropiado!',
      invalid_format:
        '[img] Solo podemos aceptar imagenes JPG, PNG, GIF o WEBP. Convierte tu foto y vuelve a intentarlo!',
      missing_title:
        '[pen] Ponle un titulo a tu publicacion para que la comunidad sepa de que trata.',
      too_short:
        '[pen] Tu mensaje es muy corto! Cuentanos un poco mas sobre tu peludo. [paw]',
      aggressive_caps:
        '[!] Hemos detectado un tono muy agresivo en tu mensaje. Recuerda que el Club Borkify es un espacio amable. Respira y vuelve a intentarlo! [paw]',
      default:
        '[!] En el Club Borkify cuidamos la paz de la manada. Tu publicacion ha sido bloqueada por no cumplir con nuestras normas de comunidad (No se permite spam, politica ni lenguaje ofensivo). Mantengamos esto divertido para los perritos! [paw]',
    };
    return messages[category] || messages.default;
  }


  // -------------------------------------------------------------
  // UI: MOSTRAR TOAST DE INFRACCION
  // -------------------------------------------------------------
  function bcfShowModToast(message, isWarning) {
    var toast = document.getElementById('bcf-mod-toast');
    var icon  = document.getElementById('bcf-mod-toast-icon');
    var title = document.getElementById('bcf-mod-toast-title');
    var body  = document.getElementById('bcf-mod-toast-body');
    if (!toast) return;
    icon.textContent  = isWarning ? 'Aviso' : 'Bloqueado';
    title.textContent = isWarning ? 'Publicacion en revision' : 'Publicacion bloqueada';
    body.textContent  = message;
    toast.classList.add('show');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function(){ toast.classList.remove('show'); }, 7000);
  }

  window.bcfHideModToast = function() {
    var toast = document.getElementById('bcf-mod-toast');
    if (toast) toast.classList.remove('show');
  };

  // -------------------------------------------------------------
  // UI: PANEL DE ADMINISTRACION
  // -------------------------------------------------------------
  window.bcfOpenAdminPanel = function() {
    var panel = document.getElementById('bcf-admin-panel');
    if (panel) { panel.classList.add('open'); bcfRenderAdminQueue(); }
  };

  window.bcfCloseAdminPanel = function() {
    var panel = document.getElementById('bcf-admin-panel');
    if (panel) panel.classList.remove('open');
  };

  function bcfUpdateAdminBadge() {
    var badge = document.getElementById('bcf-flagged-count');
    var btn   = document.getElementById('bcf-admin-btn');
    if (!badge || !btn) return;
    var flagged = BCF_REVIEW_QUEUE.filter(function(p){ return p.status === 'flagged'; });
    badge.textContent = flagged.length;
    btn.style.display = (flagged.length > 0 && BCF_MOD_CONFIG.IS_ADMIN) ? 'flex' : 'none';
  }


  function bcfRenderAdminQueue() {
    var queue  = document.getElementById('bcf-admin-queue');
    if (!queue) return;
    var flagged = BCF_REVIEW_QUEUE.filter(function(p){ return p.status === 'flagged'; });
    if (flagged.length === 0) {
      queue.innerHTML = '<div class="bcf-admin-empty"><span>OK</span>No hay publicaciones pendientes de revision. La manada esta siendo buena!</div>';
      return;
    }
    queue.innerHTML = flagged.map(function(post) {
      var safeTitle = bcfSafeText(post.title);
      var safeBody  = bcfSafeText(post.body);
      var safeName  = bcfSafeText(post.authorName);
      var safeDate  = new Date(post.createdAt).toLocaleString('es-ES');
      var scoreStr  = Math.round((post.modScore || 0) * 100) + '%';
      var imgHtml   = post.imagePreview ? '<img class="rc-image" src="' + post.imagePreview + '" alt="Imagen">' : '';
      return '<div class="bcf-review-card" id="review-card-' + post.id + '">' +
        '<div class="rc-meta">' +
        '<img class="rc-avatar" src="https://api.dicebear.com/7.x/adventurer/svg?seed=' + safeName + '" alt="Avatar">' +
        '<div><div class="rc-author">' + safeName + '</div><div class="rc-date">' + safeDate + '</div></div>' +
        '<span class="bcf-post-status-badge bcf-badge-flagged" style="margin-left:auto;">En revision</span>' +
        '</div>' +
        '<div class="rc-reason">Razon: <strong>' + (post.modReason || 'contenido sospechoso') + '</strong> | Score: <strong>' + scoreStr + '</strong> | Capa: <strong>' + (post.modLayer || '-') + '</strong></div>' +
        imgHtml +
        '<div class="rc-content"><strong>' + safeTitle + '</strong><br>' + safeBody + '</div>' +
        '<div class="rc-actions">' +
        '<button class="bcf-btn-approve" onclick="bcfAdminApprove(' + "'" + post.id + "'" + ')">Aprobar y publicar</button>' +
        '<button class="bcf-btn-reject"  onclick="bcfAdminReject(' + "'" + post.id + "'" + ')">Rechazar</button>' +
        '<button class="bcf-btn-edit"    onclick="bcfAdminReject(' + "'" + post.id + "'" + ', true)">Eliminar</button>' +
        '</div></div>';
    }).join('');
  }


  // Aprobar post desde panel admin
  window.bcfAdminApprove = function(postId) {
    var idx = BCF_REVIEW_QUEUE.findIndex(function(p){ return p.id === postId; });
    if (idx === -1) return;
    var post = BCF_REVIEW_QUEUE[idx];
    post.status = 'approved';
    post.reviewedAt = new Date().toISOString();
    var approved = Object.assign({}, post, { status: 'approved' });
    bcfPublishToFeed(approved);
    BCF_REVIEW_QUEUE.splice(idx, 1);
    bcfRenderAdminQueue();
    bcfUpdateAdminBadge();
    bcfToast('Publicacion aprobada y publicada en el feed', 'success');
  };

  window.bcfAdminReject = function(postId, silent) {
    var idx = BCF_REVIEW_QUEUE.findIndex(function(p){ return p.id === postId; });
    if (idx === -1) return;
    BCF_REVIEW_QUEUE[idx].status = 'rejected';
    BCF_REVIEW_QUEUE.splice(idx, 1);
    bcfRenderAdminQueue();
    bcfUpdateAdminBadge();
    if (!silent) bcfToast('Publicacion rechazada y eliminada', 'error');
  };


  function bcfPublishToFeed(post) {
    var feed = document.getElementById('bcf-feed');
    if (!feed) return;
    var card = document.createElement('div');
    card.className = 'bcf-post-card animate-fade-in';
    card.setAttribute('data-id', post.id);
    card.setAttribute('data-tag', post.tag);
    card.setAttribute('data-status', 'approved');
    var avatarUrl = 'https://api.dicebear.com/7.x/adventurer/svg?seed=' + bcfSafeText(post.authorName);
    var imgHtml = post.imagePreview ? '<img src="' + post.imagePreview + '" class="bcf-card-image" alt="Foto del post">' : '';
    card.innerHTML =
      '<div class="bcf-card-header">' +
      '<img class="bcf-avatar" src="' + avatarUrl + '" alt="' + bcfSafeText(post.authorName) + '">' +
      '<div class="bcf-author-info"><div class="bcf-author-name">' + bcfSafeText(post.authorName) + '</div>' +
      '<div class="bcf-post-time">Ahora mismo</div></div>' +
      '<span class="bcf-tag-badge" style="background:' + post.tagColor + ';color:#fff">' + post.tagLabel + '</span>' +
      '</div>' + imgHtml +
      '<div class="bcf-card-body"><h3 class="bcf-card-title">' + bcfSafeText(post.title) + '</h3>' +
      '<p class="bcf-card-excerpt">' + bcfSafeText(post.body) + '</p></div>' +
      '<div class="bcf-card-footer">' +
      '<button class="bcf-like-btn" onclick="bcfLike(this)"><span class="bcf-paw">0</span><span class="bcf-like-count">0</span></button>' +
      '<button class="bcf-comment-btn">0 respuestas</button>' +
      '<button class="bcf-share-btn" onclick="bcfShare(' + "'" + post.id + "'" + ')">Compartir</button>' +
      '</div>';
    feed.insertBefore(card, feed.firstChild);
    card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }


  function bcfSafeText(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  function bcfShowModSpinner(show, message) {
    var spinner = document.getElementById('bcf-mod-spinner');
    if (!spinner) {
      spinner = document.createElement('div');
      spinner.id = 'bcf-mod-spinner';
      spinner.className = 'bcf-mod-spinner';
      spinner.innerHTML = '<div class="bcf-spin"></div><span>Analizando contenido con IA...</span>';
      var form = document.getElementById('bcf-create-form');
      if (form) form.prepend(spinner);
    }
    if (show) {
      spinner.querySelector('span').textContent = message || 'Analizando contenido con IA...';
      spinner.classList.add('active');
    } else {
      spinner.classList.remove('active');
    }
  }

  window.bcfHandleImagePreview = function(input) {
    var preview  = document.getElementById('bcf-img-preview');
    var statusEl = document.getElementById('bcf-img-mod-status');
    if (!input.files || !input.files[0] || !preview) return;
    var file = input.files[0];
    preview.style.display = 'block';
    preview.src = URL.createObjectURL(file);
    if (statusEl) {
      statusEl.style.display = 'block';
      statusEl.style.background = '#FEF3C7';
      statusEl.style.color = '#92400E';
      statusEl.textContent = 'Analizando imagen...';
    }
    bcfImageModerationPipeline(file).then(function(result) {
      if (!statusEl) return;
      if (result.status === 'approved') {
        statusEl.style.background = '#D1FAE5';
        statusEl.style.color = '#065F46';
        statusEl.textContent = 'Imagen verificada - lista para publicar';
      } else if (result.status === 'flagged') {
        statusEl.style.background = '#FEF3C7';
        statusEl.style.color = '#92400E';
        statusEl.textContent = 'Imagen en revision - se publicara tras aprobacion';
      } else {
        statusEl.style.background = '#FFE4E4';
        statusEl.style.color = '#9B1C1C';
        statusEl.textContent = result.userMessage || 'Esta imagen no puede publicarse';
        input.value = '';
        preview.style.display = 'none';
      }
    });
    window._pendingImageFile = file;
  };

  window._pendingImageFile = null;


  // -------------------------------------------------------------
  // INICIALIZACION DEL SISTEMA DE MODERACION (VERSION LIMPIA)
  // CSS y HTML ya estan en el DOM - solo activar la logica
  // -------------------------------------------------------------
  function bcfInitModeration() {
    // Admin badge
    bcfUpdateAdminBadge();

    // Activar modo admin si URL tiene ?borkiadmin=1
    if (window.location.search.indexOf('borkiadmin=1') !== -1) {
      BCF_MOD_CONFIG.IS_ADMIN = true;
      bcfUpdateAdminBadge();
      console.log('[Borkify Mod] Modo Admin activado');
    }

    // Mejorar modal de creacion con campo de imagen
    bcfUpgradeCreateModal();

    console.log('[Borkify Mod] Sistema de moderacion inicializado OK');
  }

  // -------------------------------------------------------------
  // MEJORA DEL MODAL DE CREACION DE POST
  // Anyade campo de imagen + indicador de moderacion
  // -------------------------------------------------------------
  function bcfUpgradeCreateModal() {
    const form = document.getElementById('bcf-create-form');
    if (!form || document.getElementById('bcf-create-image')) return;

    const imgGroup = document.createElement('div');
    imgGroup.className = 'bcf-form-group';
    imgGroup.innerHTML = '<label class="bcf-form-label">Anyadir foto (opcional)</label>' +
      '<input type="file" id="bcf-create-image" accept="image/jpeg,image/png,image/gif,image/webp"' +
      ' onchange="bcfHandleImagePreview(this)"' +
      ' style="width:100%;padding:8px;border:2px dashed #ddd;border-radius:10px;font-size:13px;cursor:pointer;background:#fafafa">' +
      '<img id="bcf-img-preview" src="" alt="Preview" style="max-width:100%;max-height:160px;border-radius:10px;margin-top:8px;display:none;object-fit:cover;">' +
      '<div id="bcf-img-mod-status" style="font-size:12px;padding:4px 10px;border-radius:6px;margin-top:4px;display:none;"></div>';

    const submitBtn = form.querySelector('button');
    if (submitBtn) {
      submitBtn.id = 'bcf-submit-post-btn';
      form.insertBefore(imgGroup, submitBtn);
    } else {
      form.appendChild(imgGroup);
    }
  }

  // Inicializar cuando DOM este listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bcfInitModeration);
  } else {
    setTimeout(bcfInitModeration, 300);
  }

})(); // END IIFE: BORKIFY MODERATION ENGINE
